import $ from "jquery";
import "slick-carousel";
import jss from 'jss'
import preset from 'jss-preset-default'
import {generateVectorPosition} from '../../../../client/utils/vector-position'

class WidgetEcfGalleryNews extends elementorModules.frontend.handlers.Base {
  getDefaultSettings() {
    return {
      selectors: {
        slider: ".ecf-carousel-list",
        slider_item: ".ecf-carousel-item",
        slideItem: '.ecf-carousel-list .slide--video',
        playButton: ".ecf-carousel-list .slide--video .play-icon"
      },
    };
  }

  getDefaultElements() {
    const selectors = this.getSettings("selectors");
    return {
      $slider: this.$element.find(selectors.slider),
      $slider_item: this.$element.find(selectors.slider_item),
      $slideItem: this.$element.find(selectors.slideItem),
      $playButton: this.$element.find(selectors.playButton)
    };
  }

  toggleVideo(slide, isEnable = true) {
    let video = $(slide).find('video')[0];
    if(video){
      let playButton = this.elements.$playButton;
      let enableToggle = isEnable ? !$(slide).hasClass('play') : false;

      $(slide).toggleClass('play', enableToggle);
      if ($(slide).hasClass('play')) {
        video.play();
        playButton.css('display', 'none');
      } else {
        video.pause();
        playButton.css('display', 'block');
        $(slide).find('.slide-img').removeClass('play');
      }
    }
  }

  bindEvents() {
    const THIS = this;
    let slider = $(this.elements.$slider);
    let slider_item = $(this.elements.$slider_item);
    let slideItem = this.elements.$slideItem;
    if (slider_item.length!=0) {
      slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        focusOnSelect: true,
        adaptiveHeight: true,
        nextArrow:
          '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next">Next</button>',
        prevArrow:
          '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev">Previous</button>',
      }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        let slide = slick.$slides[currentSlide];
       // THIS.toggleVideo(slide, false);
      });
      slideItem.on('click', function(event) {
        THIS.toggleVideo(this);
      });
    }
  }
}

jQuery(window).on("elementor/frontend/init", () => {
  const addHandler = ($element) => {
    elementorFrontend.elementsHandler.addHandler(WidgetEcfGalleryNews, {
      $element,
    });
  };

  elementorFrontend.hooks.addAction(
    "frontend/element_ready/ecf_gallery_news.default",
    addHandler
  );
});
